// Shared color constants for consistent theming
export const STATUS_WARNING_COLOR = '#E7B41A'
